import { call, put, select, takeLatest } from "redux-saga/effects";
import axiosInstance from "utils/axiosInstance";
import { fetchImage } from "utils/images/imageManager";

import { FETCH_MISSING_IMAGES } from "store/imageMap/actionTypes";

// Redux States
import { 
  FETCH_STORE_MENU,
  FETCH_MENU_IMAGES,
  FETCH_USER_POINTS,
  FETCH_STORE_MENU_SUCCESS,
  FETCH_STORE_MENU_FAILURE,
  FETCH_MENU_COLUMNS_SUCCESS,
  FETCH_MENU_IMAGES_SUCCESS,
} from "./actionTypes";

function* fetchStoreMenuSaga() {
  try {
    const menuResponse = yield call(axiosInstance.get, `/knovia/myInfo/storeMenu`);
    const storeMenu = menuResponse.data.result;

    yield put({ type: FETCH_STORE_MENU_SUCCESS, payload: storeMenu });

    const columnRes = yield call(axiosInstance.post, `/knovia/myInfo/storeMenuItems`, {
      content: storeMenu
    });
    const menuContent = columnRes.data.result;
    
    yield put({ type: FETCH_MENU_COLUMNS_SUCCESS, payload: menuContent });

    // Collect all images from menuContent
    const allImages = menuContent
      .flatMap(section => section.content)
      .map(item => item.image)
      .filter(Boolean);

    yield put({ 
      type: FETCH_MISSING_IMAGES, 
      payload: { filenames: allImages, size: "original" } 
    });

  } catch (error) {
    console.error("[fetchStoreMenuSaga] error", error);
    yield put({ type: FETCH_STORE_MENU_FAILURE, payload: error.message });
  }
}

/*
function* fetchMenuImagesSaga(action) {
  const menuContent = action.payload;
  const BATCH_SIZE = 5;

  // 🔑 Get existing imageMap from Redux
  const existingImageMap = yield select(state => state.storeMenu.imageMap);
  const newMap = new Map(existingImageMap); // clone

  const allItems = menuContent.flatMap(section => section.content);
  const itemsToFetch = allItems.filter(item => {
    return item.image && !newMap.has(item.image);
  });

  for (let i = 0; i < itemsToFetch.length; i += BATCH_SIZE) {
    const batch = itemsToFetch.slice(i, i + BATCH_SIZE);

    const results = yield Promise.all(batch.map(async (item) => {
      try {
        const url = await fetchImage(item.image, "original");
        return { filename: item.image, url };
      } catch (e) {
        return null;
      }
    }));

    for (const result of results) {
      if (result) newMap.set(result.filename, result.url);
    }

    yield put({ type: FETCH_MENU_IMAGES_SUCCESS, payload: new Map(newMap) });
  }
}
*/

function* storeMenuSaga() {
  yield takeLatest(FETCH_STORE_MENU, fetchStoreMenuSaga);
  //yield takeLatest(FETCH_MENU_IMAGES, fetchMenuImagesSaga);
}

export default storeMenuSaga;


